import { ShieldCheck, GraduationCap, HardHat, ClipboardCheck } from 'lucide-react';
import SectionHeading from './SectionHeading';

// ✅ Import directo de la imagen local
import safetyImage from '@/assets/images/safety.jpg';

const safetyItems = [
  { icon: ShieldCheck, label: 'Seguridad' },
  { icon: GraduationCap, label: 'Capacitación' },
  { icon: HardHat, label: 'Equipo de protección' },
  { icon: ClipboardCheck, label: 'Buenas prácticas' },
];

const Safety = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:px-8">
        {/* Contenido textual */}
        <div>
          <SectionHeading
            eyebrow="Operación responsable"
            title="SEGURIDAD E HIGIENE"
          />

          <div className="mt-7 space-y-4 leading-7 text-slate-600">
            <p className="text-justify">
              Nuestro personal recibe capacitación en las normas de Seguridad e
              Higiene fijadas por la ley y por cada empresa.
            </p>
            <p className="text-justify">
              Conoce las hojas de seguridad y el manejo seguro de las sustancias
              utilizadas durante su trabajo, así como el uso adecuado de las
              herramientas necesarias.
            </p>
          </div>

          <div className="mt-9 grid grid-cols-2 gap-3">
            {safetyItems.map((item) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.label}
                  className="flex items-center gap-3 border border-slate-200 p-4"
                >
                  <Icon className="shrink-0 text-[#00a7e2]" size={21} />
                  <span className="text-sm font-bold text-[#0A2540]">
                    {item.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Imagen */}
        <img
          src={safetyImage}
          alt="Personal con equipo de protección profesional"
          className="aspect-[4/3] w-full object-cover"
        />
      </div>
    </section>
  );
};

export default Safety;